export const currencyToFloat = currencyString => {
  const normalizedValue = currencyString
    .replace('R$', '')
    .replace('.', '')
    .replace(',', '.');

  return parseFloat(normalizedValue);
};

export const formatPrice = (price, showCurrency = true) => {
  if (typeof price === 'number') {
    const priceWithDecimal = price.toFixed(2).replace('.', ',');
    const formattedPrice = addDots(priceWithDecimal);

    if (showCurrency) {
      return `R$ ${formattedPrice}`;
    }

    return formattedPrice;
  }

  return null;
};

function addDots(n) {
  const rx = /(\d+)(\d{3})/;

  return String(n).replace(/^\d+/, w => {
    let res = w;
    while (rx.test(res)) {
      res = res.replace(rx, '$1.$2');
    }
    return res;
  });
}

export default {
  currencyToFloat,
  formatPrice,
};



// WEBPACK FOOTER //
// ../utils/functions/currency.js